import ErrorConstants from '../constants/ErrorConstants';

/**
 * Tell the reducer to store the notice ID in the redux store.
 * @param  {object} error
 * @return {object]}
 */

function storeInternalError(error = {}) {
  return {
    type: ErrorConstants.STORE_INTERNAL_ERROR,
    payload: {
      error
    }
  };
}

export default {
  storeInternalError
};



// WEBPACK FOOTER //
// ./app/actions/ErrorActions.js